import { LongOpParametersTypeDecorator, LongOpResultTypeDecorator, LongOpRootViewModel, NumericPropertyViewModel } from "@nts/std";
import { ReceiptLongOp } from "../domain-models/receipt-long-op";
import { ReceiptLongOpIdentity } from "../domain-models/receipt-long-op-identity";
import { ReceiptParams } from "../domain-models/receipt-params";
import { ReceiptResult } from "../domain-models/receipt-result";
import { ReceiptParamsViewModel } from "./receipt-params.view-model";
import { ReceiptResultViewModel } from "./receipt-result.view-model";
import { ExpenseClassification } from "../generated/domain-models/enums/generated-expense-classification";

@LongOpParametersTypeDecorator(ReceiptParamsViewModel)
@LongOpResultTypeDecorator(ReceiptResultViewModel)
export class ReceiptLongOpViewModel extends LongOpRootViewModel<ReceiptLongOp, ReceiptLongOpIdentity, ReceiptParamsViewModel,
  ReceiptResultViewModel, ReceiptParams, ReceiptResult> {

  private _id: NumericPropertyViewModel;

  public get id(): NumericPropertyViewModel {
    return this.getNumericPropertyViewModel((value) => { this._id = value; }, this._id, 'id');
  }

  forwardWithNoReceipt: boolean = false;
  isDraft: boolean | null = null;

  validateAllSteps(): boolean {
    this.params.paymentData.extendedPaymentTypeRef.isRequired = this.params.paymentData.currentExpenseClassificationType !== ExpenseClassification.MileageRefound;
    this.params.expenseData.extendedExpenseTypeRef.isRequired = true;

    this.params.expenseModelData.validateStep().then(() => { }).catch(() => { });
    if (!this.params.expenseModelData.isValid.value) {
      return false;
    }
    this.params.expenseData.validateStep().then(() => { }).catch(() => { });
    if (!this.params.expenseData.isValid.value) {
      return false;
    }
    this.params.paymentData.validateStep().then(() => { }).catch(() => { });
    if (!this.params.paymentData.isValid.value) {
      return false;
    }
    this.params.expenseSelection.validateStep().then(() => { }).catch(() => { });
    if (!this.params.expenseSelection.isValid.value) {
      return false;
    }

    if (!this.params.expenseData.isLastStep()) {
      switch (this.params.expenseData.currentExpenseClassificationType) {
        case ExpenseClassification.Food:
          this.params.foodData.validateStep().then(() => { }).catch(() => { });
          if (!this.params.foodData.isValid.value) {
            return false;
          }
          break;
        case ExpenseClassification.Accommodation:
          this.params.accommodationData.validateStep().then(() => { }).catch(() => { });
          if (!this.params.accommodationData.isValid.value) {
            return false;
          }
          break;
        case ExpenseClassification.MileageRefound:
          this.params.mileageRefoundData.validateStep().then(() => { }).catch(() => { });
          if (!this.params.mileageRefoundData.isValid.value) {
            return false;
          }
          break;
        case ExpenseClassification.Other:
          this.params.otherData.validateStep().then(() => { }).catch(() => { });
          if (!this.params.otherData.isValid.value) {
            return false;
          }
          break;
        case ExpenseClassification.Transport:
          this.params.transportData.validateStep().then(() => { }).catch(() => { });
          if (!this.params.transportData.isValid.value) {
            return false;
          }
          break;
        default:
          return false;
      }
    }


    return true;
  }
}
